import React from "react";
import "../template-file-css/document-file-template.css";

export const LSS_OrderOfServices = ({ itemsRef, showErrorFor }) => {
    return (
        <form id="LSS_OrderOfServices" className="file-pdf-document">
            <div className="file-template">
                <table>
                    <tr>
                        <td className="w-100"></td>
                        <td className="w-650">
                            <p>
                                <strong>
                                    Based upon the Comprehensive (Biopsychosocial) Assessment
                                    and/or other relevant information, I order for the Individual
                                    to receive the following checked services:
                                </strong>
                            </p>
                        </td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className="w-100"></td>
                        <td>
                            <h3>ONLY CHECK SERVICES THAT ARE BEING PROVIDED</h3>
                        </td>
                    </tr>

                    <tr>
                        <td className="w-50"></td>
                        <td className="w-325">
                            <h4>
                                Non-Medical Orders: <br />
                                (Licensed Clinician Only)
                            </h4>
                        </td>
                        <td className="w-50"></td>
                        <td className="w-325">
                            <h4>
                                Medical Order: <br />
                                (Physician/APRN Only)
                            </h4>
                        </td>
                    </tr>

                    <tr>
                        <td className="w-50">
                            <input
                                type="checkbox"
                                id="txtNon_MedicalOrders_1"
                                name="txtNon_MedicalOrders_1"
                                className="add-only"
                            />
                        </td>
                        <td className="w-325">
                            Behavioral Health Assessment/ Service Plan Development
                        </td>
                        <td className="w-50">
                            <input
                                type="checkbox"
                                id="txt_MedicalOrders_1"
                                name="txt_MedicalOrders_1"
                                className="add-only"
                            />
                        </td>
                        <td className="w-325">Diagnostic Assessment (MD Only)</td>
                    </tr>

                    <tr>
                        <td className="w-50">
                            <input
                                type="checkbox"
                                id="txtNon_MedicalOrders_2"
                                name="txtNon_MedicalOrders_2"
                                className="add-only"
                            />
                        </td>
                        <td className="w-325">Crisis Intervention</td>
                        <td className="w-50">
                            <input
                                type="checkbox"
                                id="txt_MedicalOrders_2"
                                name="txt_MedicalOrders_2"
                                className="add-only"
                            />
                        </td>
                        <td className="w-325">
                            Psychiatric Care/Physician Assessment (MD Only)
                        </td>
                    </tr>

                    <tr>
                        <td className="w-50">
                            <input
                                type="checkbox"
                                id="txtNon_MedicalOrders_3"
                                name="txtNon_MedicalOrders_3"
                                className="add-only"
                            />
                        </td>
                        <td className="w-325">Community Support (C&A)</td>
                        <td className="w-50">
                            <input
                                type="checkbox"
                                id="txt_MedicalOrders_3"
                                name="txt_MedicalOrders_3"
                                className="add-only"
                            />
                        </td>
                        <td className="w-325">
                            Nursing Assessment/Health Services (MD Only)
                        </td>
                    </tr>

                    <tr>
                        <td className="w-50">
                            <input
                                type="checkbox"
                                id="txtNon_MedicalOrders_4"
                                name="txtNon_MedicalOrders_4"
                                className="add-only"
                            />
                        </td>
                        <td className="w-325">Case Management (Adults)</td>
                        <td className="w-50">
                            <input
                                type="checkbox"
                                id="txt_MedicalOrders4"
                                name="txt_MedicalOrders4"
                                className="add-only"
                            />
                        </td>
                        <td className="w-325">Medication Administration (MD Only)</td>
                    </tr>

                    <tr>
                        <td className="w-50">
                            <input
                                type="checkbox"
                                id="txtNon_MedicalOrders_5"
                                name="txtNon_MedicalOrders_5"
                                className="add-only"
                            />
                        </td>
                        <td className="w-325">
                            Psychosocial Rehabilitation-Individual (Adults)
                        </td>
                        <td className="w-50">
                            <input
                                type="checkbox"
                                id="txt_MedicalOrders5"
                                name="txt_MedicalOrders5"
                                className="add-only"
                            />
                        </td>
                        <td className="w-325">Psychological Testing</td>
                    </tr>

                    <tr>
                        <td className="w-50">
                            <input
                                type="checkbox"
                                id="txtNon_MedicalOrders_6"
                                name="txtNon_MedicalOrders_6"
                                className="add-only"
                            />
                        </td>
                        <td className="w-325">
                            Psychosocial Rehabilitation-Group (Adults)
                        </td>
                    </tr>

                    <tr>
                        <td className="w-50">
                            <input
                                type="checkbox"
                                id="txtNon_MedicalOrders_7"
                                name="txtNon_MedicalOrders_7"
                                className="add-only"
                            />
                        </td>
                        <td className="w-325">Individual Counseling</td>
                    </tr>

                    <tr>
                        <td className="w-50">
                            <input
                                type="checkbox"
                                id="txtNon_MedicalOrders_8"
                                name="txtNon_MedicalOrders_8"
                                className="add-only"
                            />
                        </td>
                        <td className="w-325">Family Training/Counseling</td>
                    </tr>

                    <tr>
                        <td className="w-50">
                            <input
                                type="checkbox"
                                id="txtNon_MedicalOrders_9"
                                name="txtNon_MedicalOrders_9"
                                className="add-only"
                            />
                        </td>
                        <td className="w-325">Group Training/Counseling</td>
                    </tr>

                    <tr>
                        <td className="w-50">
                            <input
                                type="checkbox"
                                id="txtNon_MedicalOrders_10"
                                name="txtNon_MedicalOrders_10"
                                className="add-only"
                            />
                        </td>
                        <td className="w-325">
                            Addictive Diseases Support Services (ADSS)
                        </td>
                    </tr>

                    <tr>
                        <td className="w-50">
                            <input
                                type="checkbox"
                                id="txtNon_MedicalOrders_11"
                                name="txtNon_MedicalOrders_11"
                                className="add-only"
                            />
                        </td>
                        <td className="w-325">Peer Support Services-Individual</td>
                    </tr>

                    <tr>
                        <td className="w-50">
                            <input
                                type="checkbox"
                                id="txtNon_MedicalOrders_12"
                                name="txtNon_MedicalOrders_12"
                                className="add-only"
                            />
                        </td>
                        <td className="w-325">Peer Support Services-Group</td>
                    </tr>

                    <tr>
                        <td className="w-50">
                            <input
                                type="checkbox"
                                id="txtNon_MedicalOrders_13"
                                name="txtNon_MedicalOrders_13"
                                className="add-only"
                            />
                        </td>
                        <td className="w-325">Peer Support Whole Health & Wellness</td>
                    </tr>

                    <tr>
                        <td className="w-50">
                            <input
                                type="checkbox"
                                id="txtNon_MedicalOrders_14"
                                name="txtNon_MedicalOrders_14"
                                className="add-only"
                            />
                        </td>
                        <td className="w-325">Psychological Testing</td>
                    </tr>

                    <tr>
                        <td className="w-50">
                            <input
                                type="checkbox"
                                id="txtNon_MedicalOrders_15"
                                name="txtNon_MedicalOrders_15"
                                className="add-only"
                            />
                        </td>
                        <td className="w-325">Community Transitioning Planning</td>
                    </tr>

                    <tr>
                        <td className="w-50">
                            <input
                                type="checkbox"
                                id="txtNon_MedicalOrders_16"
                                name="txtNon_MedicalOrders_16"
                                className="add-only"
                            />
                        </td>
                        <td className="w-325">Diagnostic Assessment</td>
                    </tr>

                    <tr>
                        <td className="w-50">
                            <input
                                type="checkbox"
                                id="txtNon_MedicalOrders_17"
                                name="txtNon_MedicalOrders_17"
                                className="add-only"
                            />
                        </td>
                        <td className="w-325">Coordination of Care</td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className="w-130"></td>
                        <td>
                            <h3>The above Non-Medical Orders have been ordered by:</h3>
                        </td>
                    </tr>
                    <tr>
                        <td className="w-250 signature">&nbsp;</td>
                        <td className="w-125 signature">&nbsp;</td>
                        <td className="w-250 signature">&nbsp;</td>
                        <td className="w-125 signature">&nbsp;</td>
                    </tr>
                    <tr>
                        <td className="w-250 small">Licensed Professional Printed Name </td>
                        <td className="w-125 small">License# </td>
                        <td className="w-250 small">
                            Licensed Professional Signature and Credentials{" "}
                        </td>
                        <td className="w-125 small">Date</td>
                    </tr>
                    <tr>
                        <td className="w-250 signature">&nbsp;</td>
                        <td className="w-125 signature">&nbsp;</td>
                        <td className="w-250 signature">&nbsp;</td>
                        <td className="w-125 signature">&nbsp;</td>
                    </tr>
                    <tr>
                        <td className="w-250 small">Licensed Professional Printed Name </td>
                        <td className="w-125 small">License# </td>
                        <td className="w-250 small">
                            Licensed Professional Signature and Credentials{" "}
                        </td>
                        <td className="w-125 small">Date</td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className="w-150"></td>
                        <td>
                            <h3>The above Medical Orders have been order by:</h3>
                        </td>
                    </tr>

                    <tr>
                        <td className="w-250 signature">&nbsp;</td>
                        <td className="w-125 signature">&nbsp;</td>
                        <td className="w-250 signature">&nbsp;</td>
                        <td className="w-125 signature">&nbsp;</td>
                    </tr>

                    <tr>
                        <td className="w-250 small">Licensed Professional Printed Name </td>
                        <td className="w-125 small">License# </td>
                        <td className="w-250 small">
                            Licensed Professional Signature and Credentials{" "}
                        </td>
                        <td className="w-125 small">Date</td>
                    </tr>
                    <tr>
                        <td className="w-250 signature">&nbsp;</td>
                        <td className="w-125 signature">&nbsp;</td>
                        <td className="w-250 signature">&nbsp;</td>
                        <td className="w-125 signature">&nbsp;</td>
                    </tr>
                    <tr>
                        <td className="w-250 small">Licensed Professional Printed Name </td>
                        <td className="w-125 small">License# </td>
                        <td className="w-250 small">
                            Licensed Professional Signature and Credentials{" "}
                        </td>
                        <td className="w-125 small">Date</td>
                    </tr>
                </table>
            </div>
        </form>
    );
};
